module.exports = __webpack_public_path__ + "media/images/registrations/testimonial_version/bg-01-41a7b4fdc9213cd5ebb882344eb590f2.png";